module.exports = __webpack_public_path__ + "static/media/intro-1.5e02ca23.svg";